import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lenis from 'lenis';

const init = () => {
  window.lenis = new Lenis({
    duration: 1.5,
  });

  let isScrolling = false;
  let scrollTimeout;
  const scrollThrottle = 100;
  window.lenis.on('scroll', e => {
    ScrollTrigger.update();

    if (!isScrolling) {
      isScrolling = true;
      document.body.classList.add('lenis-scrolling');

      if (e.direction === -1) {
        document.body.classList.add('lenis-scrolling-up');
      } else {
        document.body.classList.remove('lenis-scrolling-up');
      }
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isScrolling = false;
      document.body.classList.remove('lenis-scrolling');
      document.body.classList.remove('lenis-scrolling-up');
    }, scrollThrottle);
  });

  gsap.ticker.add(time => {
    window.lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  window.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (a) e.preventDefault();
  });

  window.addEventListener('pointerup', e => {
    const a = e.target.closest('a[href^="#"]');
    if (a) {
      e.preventDefault();
      const target = document.querySelector(a.getAttribute('href'));
      if (target && target.initialTop !== undefined) {
        window.scrollTo({ top: target.initialTop, behavior: 'smooth' });
      } else {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

  window.addEventListener('load', () => {
    window.lenis.resize();
  });
};

const module = () => {
  init();
};

export default module;
